export default __webpack_public_path__ + "static/media/logout.7382e602.svg";